import { PremiumPurchasePlatformModule } from '@wix/premium-purchase-platform/@sdk';
import { StudioOfferingApiClientContext } from '../studio-offering.context';
export const fetchOfferingQueryFn = async props => {
  const {
    httpClient
  } = props;
  const {
    getPurchaseUserOffering
  } = PremiumPurchasePlatformModule.SDK.ApiClient.queries({
    httpClient
  });
  const p3Context = StudioOfferingApiClientContext.get('p3Context');
  if (!p3Context) {
    throw new Error('P3 context is required to fetch offering');
  }
  const offeringData = await getPurchaseUserOffering({
    ...p3Context
  });
  return offeringData;
};
//# sourceMappingURL=fetch-offering.query.js.map